import React, { useState, useEffect } from 'react';
import styles from './index.module.sass';
import classname from 'classnames/bind';

const cx = classname.bind(styles);

const FormInput = React.forwardRef(
  (
    {
      preValue,
      label,
      labelFor,
      disabled = false,
      value = '',
      maxLength,
      placeholder,
      onTextChanged,
      onKeyPress,
      onFocus,
      digits,
      inputMode,
      errorMessage = '',
      allCap = false,
      type = 'text',
      button,
      className,
    },
    ref
  ) => {
    const [text, setText] = useState(value);

    const onChangeHandle = event => {
      let newText = event.target.value;

      if (preValue) {
        if (newText.match(`^${preValue}.*`)) {
          console.log(newText);
          newText = newText.replace(preValue, '');
        }
      }

      if (allCap) {
        newText = newText.toUpperCase();
      }

      if (maxLength && newText.length >= maxLength) {
        newText = newText.substring(0, maxLength);
      }

      newText = matchDigits(newText) ? newText : text;
      setText(newText);
      if (onTextChanged) {
        onTextChanged(newText);
      }
    };

    const onBlur = () => {
      // 比照花旗行動市集的webview bug
      // 在鍵盤縮回後強制滾動至畫面頂端
      // 參考：https://github.com/apache/cordova-ios/issues/417
      window.scrollBy(0, 0);
    };

    const onKeyChange = event => {
      if (event.key === 'Enter' && onKeyPress) {
        onKeyPress();
      }
    };

    const matchDigits = value => {
      const latestChar = value.charAt(value.length - 1);
      if (digits !== '' && value !== '') {
        return latestChar.match(digits) !== null;
      } else {
        return true;
      }
    };

    const formInputClass = cx({
      'form-input': true,
      error: errorMessage !== '',
      disabled,
    });

    const errorMessageClass = cx({
      'error-message': true,
      show: errorMessage !== '',
    });

    useEffect(() => {
      if (allCap) {
        setText(value.toUpperCase());
      } else {
        setText(value);
      }
    }, [value, allCap]);

    return (
      <>
        {label && (
          <label className={styles.label} htmlFor={labelFor}>
            {label}
          </label>
        )}
        <div className={`${formInputClass} ${className}`}>
          <span style={{ marginRight: '2px' }}>{preValue}</span>
          <input
            name={labelFor}
            ref={ref}
            type={type}
            inputMode={inputMode}
            value={text}
            maxLength={maxLength}
            onFocus={onFocus}
            onBlur={onBlur}
            onKeyPress={onKeyChange}
            onChange={onChangeHandle}
            placeholder={placeholder}
            disabled={disabled}
          />
          {button}
        </div>
        <div className={errorMessageClass}>{errorMessage}</div>
      </>
    );
  }
);

export default FormInput;
